import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import config from 'devextreme/core/config';
import { DEVEXTREME_LICENSE_KEY } from './app/config/constants';
import { AppModule } from './app/app.module';



config({ licenseKey: DEVEXTREME_LICENSE_KEY });



platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .catch((err) => console.error(err));
